'use strict'

/**
 * アコーディオンの動作制御
 */
export default () => {
  const func = {
    BUTTON: document.querySelectorAll('.js-accordion-btn'),

    /**
     * init
     */
    init: () => {
      func.BUTTON.forEach(btn => {
        btn.addEventListener('click', () => {
          func.switchShowHide(btn)
        })
      })
    },

    /**
     * show
     */
    show: (btn) => {
      btn.classList.add('is-opened')
      btn.nextElementSibling.style.height = func.getHeight(btn.nextElementSibling.firstElementChild) + 'px'
    },

    /**
     * hide
     */
    hide: (btn) => {
      btn.classList.remove('is-opened')
      btn.nextElementSibling.style.height = 0
    },

    /**
     * getHeight
     */
    getHeight: (target) => {
      return target.clientHeight
    },

    /**
     * switchShowHide
     */
    switchShowHide: (btn) => {
      btn.classList.contains('is-opened') ? func.hide(btn) : func.show(btn)
    },
  }

  func.init()
}
